module.exports = __webpack_public_path__ + "static/media/rihanna_tweet.0ca1dd4e.jpeg";